module.exports = __webpack_public_path__ + "img/user-photo.7601e3c8.png";